import request from '@/http/axios'
import Api from '@/http/api'

export const sendCode = (data) =>
  request({
    url: Api.commonNew.sendCode,
    method: 'get',
    params: data
  })
